// extracted by mini-css-extract-plugin
export default {"description":"ClaimInfo_description__PbJlu","details":"ClaimInfo_details__RGhRD","caption":"ClaimInfo_caption__E1vsH"};